module.exports = __webpack_public_path__ + "static/media/tier-6.2cab7261.jpg";